import React from "react";

export default function FAQ() {
  return (
    <div className="agn-modern-faq-wrapper">
      <style>{`
        .agn-modern-faq-wrapper {
        
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .faq-container {
          position: relative;
          z-index: 1;
        }

        .faq-visual {
          position: sticky;
          top: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .faq-visual img {
          width: 90%;
          border-radius: 40px;
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
          transition: all 0.5s ease;
        }

        .faq-visual:hover img {
          transform: translateY(-10px);
        }

        .faq-header {
          margin-bottom: 40px;
          text-align: left;
        }

        .faq-header span {
          display: block;
          font-family: var(--font-primary);
          font-size: var(--label-size);
          font-weight: var(--label-weight);
          color: var(--theme-color);
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 12px;
        }

        .faq-header h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          color: #111;
          line-height: var(--lh-tight);
        }

        .faq-accordion .accordion-item {
          border: 1px solid rgba(0, 0, 0, 0.05) !important;
          border-radius: 20px !important;
          margin-bottom: 15px;
          overflow: hidden;
          background: #fff;
        }

        .faq-button {
          width: 100%;
          padding: 22px 30px;
          background: #ffffff !important;
          border: none !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: left;
          font-family: var(--font-primary);
          font-size: 0.95rem;
          font-weight: 700;
          color: #333 !important;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: none !important;
        }

        /* Remove default bootstrap arrow */
        .faq-button::after {
          display: none !important;
        }

        .faq-button:not(.collapsed) {
          color: var(--theme-color) !important;
          border-bottom: 1px solid rgba(0, 0, 0, 0.03);
        }

        .faq-icon-box {
          width: 30px;
          height: 30px;
          background: rgba(var(--theme-color-rgb), 0.08);
          color: var(--theme-color);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          flex-shrink: 0;
          font-size: 0.75rem;
        }

        .faq-button:not(.collapsed) .faq-icon-box {
          background: var(--theme-color);
          color: #fff;
          transform: rotate(180deg);
        }

        .faq-body {
          padding: 25px 30px;
          color: #666;
          font-family: var(--font-secondary);
          font-size: var(--small-size);
          line-height: var(--lh-relaxed);
          font-weight: 400;
        }

        @media (max-width: 991px) {
          .faq-visual {
            margin-bottom: 60px;
            position: static;
          }
          .faq-header {
            text-align: center;
          }
        }
      `}</style>

      <div className="container faq-container">
        <div className="row g-5 align-items-center">
          {/* Left Column: Image */}
          <div className="col-lg-5">
            <div className="faq-visual">
              {/* <img
                src="assets/images/img/faq.png"
                alt="Frequently Asked Questions"
                className="img-fluid"
                onError={(e) => { e.target.src = "assets/images/img/faq.png" }}
              /> */}

               <video
      className="img-fluid rounded-3"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src="assets/images/img/faq_video.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
            </div>
          </div>

          {/* Right Column: FAQ Content */}
          <div className="col-lg-7">
            <div className="faq-header">
              {/* <span>Help Center</span> */}
              <h2>Frequently Asked Questions</h2>
            </div>

            <div className="accordion faq-accordion" id="faqAccordion">
              {/* Question 1 */}
              <div className="faq-item accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="faq-button accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                    aria-expanded="true"
                    aria-controls="faq1"
                  >
                    1.  What is AGN?

                    <div className="faq-icon-box">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div className="faq-body" style={{ textAlign: "left" }}>
                    AGN is a hybrid financial platform combining asset-based and market-based income systems.

                  </div>
                </div>
              </div>

              {/* Question 2 */}
              <div className="faq-item accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="faq-button accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                    aria-expanded="false"
                    aria-controls="faq2"
                  >
                    2. How do earnings work?

                    <div className="faq-icon-box">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="faq-body" style={{ textAlign: "left" }}>
                    Users earn through asset participation, bonuses, and optional network growth.
                  </div>
                </div>
              </div>

              {/* Question 3 */}
              <div className="faq-item accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="faq-button accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq3"
                    aria-expanded="false"
                    aria-controls="faq3"
                  >
                    3. Is prior experience required?

                    <div className="faq-icon-box">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="faq-body" style={{ textAlign: "left" }}>
                    No, AGN is designed for both beginners and experienced participants.

                  </div>
                </div>
              </div>

              {/* Question 4 */}
              <div className="faq-item accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="faq-button accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq4"
                    aria-expanded="false"
                    aria-controls="faq4"
                  >
                    4. What makes AGN unique?

                    <div className="faq-icon-box">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="faq-body" style={{ textAlign: "left" }}>
                    Its dual-model approach combining finance + trading mechanisms.

                  </div>
                </div>
              </div>

              {/* Question 5 */}
              <div className="faq-item accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="faq-button accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq5"
                    aria-expanded="false"
                    aria-controls="faq5"
                  >
                    5.Are there any charges?

                    <div className="faq-icon-box">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="faq-body" style={{ textAlign: "left" }}>
                    No administrative charges are applied.

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
